export default function isAuthorised(response) {
  if (!response) {
    return true;
  }
  return (response.status !== 401 && response.status !== 403);
}



// WEBPACK FOOTER //
// ./app/utils/unauthoriseValidator.js